export const APP_STATES = {
  HISTORICO: 'DEADBEEF-0000-4CDE-ABCD-112233445566',
  ACTIVO: 'A1B2C3D4-5678-49AB-BCDE-1234567890AB',
  CERRADO: 'C0FFEE00-1234-4B56-8DEF-9876543210FE',
  BORRADOR: 'BB50CFE4-4563-41E3-8425-9A8F8F9136D5',
};

export default APP_STATES;